import React, { useState } from 'react'
import Select from 'react-select'
import * as Icon from 'feather-icons-react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

function AppSwitch({ value }) {
    const history = useHistory()
    const [option, setOption] = useState([{ label: 'Observation', value: 'observation' }, { label: 'ePermit Work', value: 'eptw' }, { label: 'Document', value: 'document' }, { label: 'integrated Risk Management', value: 'risk' }, { label: 'Incident', value: 'incident' }, { label: 'Knowledge', value: 'knowledge' }, { label: 'Asset', value: 'asset' },{ label: 'Good Catch', value: 'catches' }, { label: 'Training Program Tracker', value: 'training-program-tracker' }, { label: 'Good Catch V2', value: 'good-catch-v2' }])


    const getApp = (e) => {
        history.push('/apps/' + e.value)

    }
    const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip  {...props} arrow classes={{ popper: className }}/>
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: theme.palette.common.black,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.black,
            padding:10
        },
    }));
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#495057',
                whiteSpace: 'nowrap'
            }}>
                Application Switcher:
            </span>
            <Select
                labelKey="label"
                id="user_description"
                placeholder="Type..."
                options={option}
                onChange={getApp}
                className={'fw-bold switchapp'}
                value={value}
                styles={{
                    control: (provided) => ({
                        ...provided,
                        minWidth: '250px'
                    }),
                    menu: provided => ({ ...provided, zIndex: 9999 })
                }}
            />
            {/* <BootstrapTooltip title="Switch between assigned applications">
                <Button><Icon.Info currentColor={'#315975'}/></Button>
            </BootstrapTooltip> */}
        </div>
    )
}

export default AppSwitch